import ReactECharts from "echarts-for-react";

interface LinePoint {
  label: string;
  value: number;
}

interface LineChartProps {
  data: LinePoint[];
  color?: string;
  height?: number;
}

export function LineChart({
  data,
  color = "#00553E",
  height = 240,
}: LineChartProps) {
  const option = {
    tooltip: { trigger: "axis" },
    grid: { left: 40, right: 16, top: 16, bottom: 32 },
    xAxis: {
      type: "category",
      data: data.map((d) => d.label),
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: { fontSize: 11 },
    },
    yAxis: {
      type: "value",
      axisLine: { show: false },
      splitLine: { lineStyle: { type: "dashed", opacity: 0.4 } },
    },
    color: [color],
    series: [
      {
        type: "line",
        data: data.map((d) => d.value),
        smooth: true,
        symbol: "circle",
        symbolSize: 6,
        areaStyle: { opacity: 0.12 },
      },
    ],
  };

  return (
    <ReactECharts option={option} style={{ width: "100%", height }} notMerge />
  );
}
